import Model from '@/entities/Model.js';
import User from '@/entities/User.js';

export default class Account extends Model {
    static get defaults() {
        return {
            monthly_segments_limit: null,
            name: null,

            // Has many
            _users: [],
        };
    }

    get users() {
        return this._users;
    }

    set users(values) {
        if (values) {
            this._users = values.map(value => new User(value));
        }
    }

    userAvailableProviderPhones(authUserId) {
        return this.providerPhones.filter(phone => phone.active && (phone.user_id == authUserId || phone.user_id == null));
    }
}
